import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import React from "react";
import { connect } from "react-redux";
import {
  fetchGenericMasterQuery,
  deleteGenericMastersQuery,
} from "../../../services/graphql/queries/masters";
import Pagination from "../../Common/Pagination";
import GenericMasterFilter from "./GenericMasterFilter";
import { getMasterStatus } from "../../Common/ListOfStatus";
import ReactModal from "../../Common/ReactModal";
import { PAGINATION_OFFSET_VALUE } from "../../../constants/app-constants";
import NotAccessible from "../../Common/NotAccessible";
import { redirectTo } from "../../../util/redirect";
import { getAccessPermisionQuery } from "../../../services/graphql/queries/accessPermission";
import queryString from "query-string";
import view from "../../../static/images/svg/view.svg";
import Delete from "../../../static/images/svg/Delete.svg";
class GenericMasterList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showFilter: false,
      pageOfItems: [],
      currentPage: 1,
      offset: PAGINATION_OFFSET_VALUE,
      loading: true,
      error: "",
      successMessage: false,
      reactModalVisible: false,
      requireCancel: false,
      modalMessage: "Are you sure Do you want to delete",
      Id: "",
      description: "",
      accessSpecifier: {},
      accessSpecifierLoading: true,
      GenericMaster_Feature_ID: 170,
      GenericMaster_Module_ID: 6,
      isDelete: false,
    };

    this.filterAction = this.filterAction.bind(this);
    this.onFilterData = this.onFilterData.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.submitModal = this.submitModal.bind(this);
    this.delete = this.delete.bind(this);
    this.filterOnChange = this.filterOnChange.bind(this);
    this.getGenericMaster = this.getGenericMaster.bind(this);
    this.addGenericMaster = this.addGenericMaster.bind(this);
    this.deleteGenericMasters = this.deleteGenericMasters.bind(this);
  }
  onFilterData(data) {
    console.log("filter data", data);
    this.setState({ pageOfItems: data });
  }
  filterAction() {
    this.setState((prevState) => {
      return {
        showFilter: !prevState.showFilter,
      };
    });
  }
  filterOnChange(data) {
    this.setState(
      {
        description: data.description,
        currentPage: data.currentPage,
      },
      () => {
        this.getGenericMaster();
      }
    );
  }
  delete(e, id) {
    if (this.state.accessSpecifier.deleteP) {
      this.setState({
        Id: id,
        reactModalVisible: true,
        requireCancel: true,
        isDelete: true,
      });
    } else {
      this.setState({
        reactModalVisible: true,
        modalMessage: "You dont have permission to do this Action",
        requireCancel: false,
      });
    }
  }

  closeModal() {
    this.setState({ reactModalVisible: false });
  }
  deleteGenericMasters() {
    this.props.client
      .mutate({
        mutation: deleteGenericMastersQuery,
        variables: {
          Id: parseInt(this.state.Id),
        },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        this.getGenericMaster();
        this.setState({ reactModalVisible: false });
      })
      .catch((error) => {});
  }
  submitModal() {
    if (this.state.isDelete) {
      this.deleteGenericMasters();
    }
    this.setState({ reactModalVisible: false });
  }
  fetchAccessSpecifier() {
    this.setState({
      loading: true,
    });
    this.props.client
      .query({
        query: getAccessPermisionQuery,
        variables: {
          moduleId: this.state.GenericMaster_Module_ID,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        let response = result.data.getFunctionByModuleId;
        response = JSON.parse(response);
        if (Object.keys(response).length != 0) {
          this.setState({
            accessSpecifier: response[this.state.GenericMaster_Feature_ID],
            accessSpecifierLoading: false,
          });
          this.getGenericMaster();
        } else {
          this.setState({
            accessSpecifierLoading: false,
          });
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: error.message,
          accessSpecifierLoading: false,
        });
      });
  }
  addGenericMaster() {
    if (this.state.accessSpecifier.createP) {
      // redirectTo(
      //   `/genericmaster-add?id=${this.props.router.query.id}&name=${this.props.router.query.name}`
      // );

      this.props.history.push(
        `/genericmaster-add?id=${
          queryString.parse(this.props.location.search).id
        }&name=${queryString.parse(this.props.location.search).name}`
      );
    } else {
      this.setState({
        reactModalVisible: true,
        modalMessage: "You dont have permission to do this Action",
        requireCancel: false,
      });
    }
  }
  onChangePage(currentPage) {
    this.state.currentPage = currentPage;
    this.getGenericMaster();
  }
  getGenericMaster() {
    this.props.client
      .query({
        query: fetchGenericMasterQuery,
        variables: {
          masterFor: parseInt(queryString.parse(this.props.location.search).id),
          offset: this.state.offset,
          pageNo: this.state.currentPage,
          descriptionName: this.state.description.trim(),
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        const genericMaster = result.data.getListofGenericMaster;
        this.initialState = {
          pageOfItems: genericMaster,
        };
        this.setState({ ...this.initialState, loading: false, error: "" });
      })
      .catch((error) => {
        this.setState({ loading: false, error: error.message });
      });
  }
  getStatus(data) {
    const statusName = getMasterStatus(data);
    return statusName[0].name;
  }
  componentDidMount() {
    this.fetchAccessSpecifier();
  }
  render() {
    const genericMaster = this.state.pageOfItems;
    const {
      loading,
      error,
      reactModalVisible,
      modalMessage,
      accessSpecifierLoading,
      accessSpecifier,
      requireCancel,
    } = this.state;
    return (
      <>
        {accessSpecifier && accessSpecifier.viewP ? (
          <>
            <ReactModal
              reactModalVisible={reactModalVisible}
              closeModal={this.closeModal}
              submitModal={this.submitModal}
              modalMessage={modalMessage}
              requireCancel={requireCancel}
            />
            <div className="row align-items-center no-gutters">
              <div className="col-md-6">
                <h1 className="heading m-b-0">{`${
                  queryString.parse(this.props.location.search).name
                } List`}</h1>
              </div>

              <div className="col-md-6 text-right">
                {/* <Link
                  href={`/genericmaster-add?id=${
                    this.props.router.query.id
                  }&name=${this.props.router.query.name}`}
                > */}
                <button
                  className="btn btn-danger"
                  onClick={this.addGenericMaster}
                >
                  {`Add ${queryString.parse(this.props.location.search).name}`}
                </button>
                {/* </Link> */}

                <button
                  className="btn btn-primary filter-btn  m-l-10"
                  onClick={this.filterAction}
                >
                  Filter
                </button>
                <GenericMasterFilter
                  showFilter={this.state.showFilter}
                  listData={this.onFilterData}
                  filterAction={() => {
                    this.state.showFilter = false;
                  }}
                  filterOnChange={this.filterOnChange}
                />
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-style-1 ">
                <thead>
                  <tr>
                    {/* <th scope="col">ID</th> */}
                    <th scope="col">DESCRIPTION</th>
                    <th scope="col">STATUS</th>
                    <th scope="col">ACTION(s)</th>
                  </tr>
                </thead>
                <tbody>
                  {genericMaster.length
                    ? genericMaster.map((data, index) => {
                        return (
                          <tr key={index}>
                            {/* <td>{data.Id} </td> */}
                            <td>{data.description} </td>
                            <td>{this.getStatus(data.status)} </td>
                            <td>
                              <Link
                                to={`/genericmaster-profile?id=${
                                  data.Id
                                }&name=${
                                  queryString.parse(this.props.location.search)
                                    .name
                                }&masterFor=${
                                  queryString.parse(this.props.location.search)
                                    .id
                                }`}
                              >
                                <a
                                  className="link-primary link-section"
                                  data-toggle="tooltip"
                                  data-placement="bottom"
                                  title="View"
                                >
                                  <img src={view} />
                                </a>
                              </Link>

                              {data.status == 4 ? (
                                <a
                                  href="#"
                                  className="link-primary m-l-45 link-section"
                                  data-toggle="tooltip"
                                  data-placement="bottom"
                                  title="Delete"
                                  onClick={(e) => {
                                    this.delete(e, data.Id);
                                  }}
                                >
                                  <img src={Delete} />
                                </a>
                              ) : null}
                            </td>
                          </tr>
                        );
                      })
                    : null}
                </tbody>
              </table>
            </div>
            {!genericMaster.length && error ? <div> {error}</div> : null}
            {!genericMaster.length && loading ? <div>Fetching...</div> : null}
            {!genericMaster.length && !error && !loading ? (
              <div style={{ textAlign: "center" }}>No Data</div>
            ) : null}
            <Pagination
              loading={loading}
              items={genericMaster}
              pageSize={this.state.offset}
              initialPage={this.state.currentPage}
              onChangePage={this.onChangePage.bind(this)}
            />
          </>
        ) : accessSpecifierLoading ? (
          <div>Fetching...</div>
        ) : (
          <NotAccessible />
        )}
      </>
    );
  }
}

export default withRouter(connect()(withApollo(GenericMasterList)));
